// PRODUCTION — form item option row editor
import React, { Fragment, useState } from 'react'
import tw from 'twin.macro'
import { DeleteConfirmButton } from './DeleteConfirmButton'

export function OptionLabel({
  value,
  onChange,
  onRemove,
}: {
  value: string
  onChange: (v: string) => void
  onRemove: () => void
}) {
  const [editing, setEditing] = useState(false)
  const [draft, setDraft] = useState(value)

  const confirm = () => {
    if (draft.trim()) {
      onChange(draft.trim())
    }

    setEditing(false)
  }

  const cancel = () => {
    setDraft(value)
    setEditing(false)
  }

  if (editing) {
    return (
      <div
        css={tw`flex h-8 flex-1 items-center overflow-hidden rounded-md border-[1.5px] border-primary-400`}
      >
        <input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              confirm()
            }

            if (e.key === 'Escape') {
              cancel()
            }
          }}
          autoFocus
          css={tw`h-full min-w-0 flex-1 border-0 bg-transparent px-2 text-sm text-shades-900 outline-none border-solid`}
        />
        <button
          type="button"
          onMouseDown={(e) => {
            e.preventDefault()
            cancel()
          }}
          css={tw`flex h-full w-[30px] cursor-pointer items-center justify-center border-0 border-l border-shades-200 bg-transparent text-shades-400 border-solid`}
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <button
          type="button"
          onMouseDown={(e) => {
            e.preventDefault()
            confirm()
          }}
          css={tw`flex h-full w-[30px] cursor-pointer items-center justify-center border-0 border-l border-shades-200 bg-transparent text-primary-500 border-solid`}
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </button>
      </div>
    )
  }

  return (
    <Fragment>
      <span
        onClick={() => {
          setDraft(value)
          setEditing(true)
        }}
        css={tw`flex-1 cursor-pointer rounded-md px-2 py-1 text-sm text-shades-900 transition-colors hover:bg-shades-50`}
      >
        {value || <span css={tw`italic text-shades-400`}>Empty</span>}
      </span>
      <DeleteConfirmButton onConfirm={onRemove} resetKey={value} />
    </Fragment>
  )
}
